import { useCallback, useEffect, useState } from 'react';
import { request } from '../utils';

// Fetches the logged-in user's scope from /auth/me. For a Doctor login it
// returns { isDoctor: true, doctorId } so report screens can auto-select and
// lock their consultant/doctor dropdown to that doctor. For everyone else it
// returns { isDoctor: false }.
export const useDoctorScope = () => {
  const [scope, setScope] = useState({ isDoctor: false, doctorId: null, loaded: false });

  const load = useCallback(async () => {
    const response = await request('/auth/me', { method: 'GET' }, true);
    if (response?.success && response.data) {
      setScope({
        isDoctor: !!response.data.isDoctor,
        doctorId: response.data.doctorId || null,
        doctorIds: response.data.doctorIds || [],
        loaded: true
      });
    } else {
      setScope({ isDoctor: false, doctorId: null, loaded: true });
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return scope;
};
